import axios from "axios";

export const LOGIN_URL = `${process.env.REACT_APP_API_URL}/v1/token`;
export const REGISTER_URL = "api/auth/register";
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";
export const PERMISSION_URL = `${process.env.REACT_APP_API_URL}/permission`;
export const USER_URL = `${process.env.REACT_APP_API_URL}/users`;
export const FORGOT_PASSWORD_URL = `${process.env.REACT_APP_API_URL}/v1/forgotpassword`;
export const VERIFY_EMAIL_URL = `${process.env.REACT_APP_API_URL}/v1/verifyemail`;

export function login(username, password) {
  return axios.post(LOGIN_URL, { username, password, source: 0 });
}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function changePassword(changePassword) {
  return axios.put(`${USER_URL}/changepassword`, changePassword);
}

export function changeProfile(user) {
  return axios.put(`${USER_URL}/changeprofile`, user);
}

export function forgotPassword(forgotPassword) {
  return axios.post(`${FORGOT_PASSWORD_URL}`, { ...forgotPassword });
}

export function resetPassword(resetPassword) {
  return axios.post(`${FORGOT_PASSWORD_URL}/reset`, { ...resetPassword });
}

export function verifyEmail(requestId) {
  return axios.put(`${VERIFY_EMAIL_URL}/${requestId}`);
}

// export function requestPassword(email) {
//   return axios.post(USER_URL, { email });
// }

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(`${USER_URL}/profile`);
}

export function getUserPermission() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(PERMISSION_URL);
}
